import VMwareCloud from "public/privateCloud/icons/vmware-cloud.png";
import { SimpleList } from "@/components/list";

export const VMWARE_SERVICES_CONSTANTS = {
  title: "VMware Cloud Services",
  desc: "VMware Cloud offers a range of services that integrate compute, storage, networking, and management solutions, enabling enterprises to optimize cloud operations.",
  list: [
    {
      image: VMwareCloud,
      title: "VMware Cloud Foundation & vSphere ",
      content: (
        <SimpleList
          points={[
            "Cloud Foundation – A unified platform combining compute, storage, networking, and cloud management",
            "vSphere – A powerful server virtualization platform for flexibility, security, and business agility.",
          ]}
        />
      ),
    },
    {
      image: VMwareCloud,
      title: "VMware vSAN – Hyper-Converged Infrastructure ",
      content: (
        <SimpleList
          points={[
            "Combines compute and storage resources for optimized performance and efficiency. ",
            "Enables scalable, software-defined storage for modern workloads. ",
          ]}
        />
      ),
    },
    {
      image: VMwareCloud,
      title: "VMware NSX – Advanced Networking & Security ",
      content: (
        <SimpleList
          points={[
            " Virtualized networking for software-defined connectivity.",
            "Integrated security features to enhance protection across cloud environments. ",
          ]}
        />
      ),
    },
    {
      image: VMwareCloud,
      title: "VMware vRealize Suite – Cloud Management ",
      content: (
        <SimpleList
          points={[
            "Provides centralized management for hybrid and multi-cloud environments. ",
            "Offers automation, monitoring, and analytics for cloud optimization. ",
          ]}
        />
      ),
    },
  ],
};
